module.exports = __webpack_public_path__ + "static/img/img_0432.f1e8343.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0432.jpg
// module id = V3OZ
// module chunks = 0